import { FormikProps } from 'formik';

export const getTouchErrorByField = (fieldName: string, { touched, errors }: FormikProps<any>) => ({
  touched: touched[fieldName],
  error: errors[fieldName],
});
